import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Rocket, Menu, X } from 'lucide-react';

const Navbar = ({ scrolled, menuOpen, setMenuOpen }) => {
  const location = useLocation();
  const page = location.pathname;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/our-story', label: 'About' },
    { path: '/knowledge-hub', label: 'Knowledge Hub' },
    { path: '/committee', label: 'Committee' },
    { path: '/events', label: 'Events' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => {
    if (path === '/' && page === '/') return true;
    if (path !== '/' && page.startsWith(path)) return true;
    return false;
  };

  return (
    <nav className={scrolled ? 'glass-nav-solid' : 'glass-nav'} style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      height: scrolled ? 64 : 80, display: 'flex', alignItems: 'center',
      transition: 'all .4s cubic-bezier(.16,1,.3,1)'
    }}>
      <div style={{ maxWidth: 1160, margin: '0 auto', width: '100%', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
          <img src="/favicon.ico" alt="ICDITC" style={{ width: 40, height: 40 }} />
          <span style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 800, color: 'var(--on-surface)', letterSpacing: '-0.02em' }} className="hide-m"></span>
        </Link>

        <div className="hide-m" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {navLinks.map(({ path, label }) => (
            <Link key={path} to={path} className={`nav-item ${isActive(path) ? 'active' : ''}`}>
              {label}
            </Link>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <Link to="/membership" className="btn btn-primary btn-sm hide-m">
            <Rocket size={14} /> Join Sync
          </Link>
          <button onClick={() => setMenuOpen(!menuOpen)} style={{
            background: 'none', border: 'none', cursor: 'pointer', padding: 8,
            color: 'var(--on-surface)', borderRadius: 4, display: 'none'
          }} className="show-m">
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
